import { useState } from "react";

import { useHistory } from "react-router-dom";

import QueryBuilder from "@/containers/QueryBuilder/QueryBuilder";
import { useAlert } from "@/contexts/AlertContext";
import Container from "@components/Container";

import Remove from "./Remove";

const General = () => {
  const history = useHistory();
  const { patchAlert } = useAlert();
  const [title, setTitle] = useState("");

  const onSave = ({ uuid, title: previousTitle }) => {
    title && previousTitle !== title && patchAlert(uuid, { title });
    history.push(".");
  };

  return (
    <Container>
      <QueryBuilder onSave={onSave} onTitleChange={(t) => setTitle(t)} />
      <Remove />
    </Container>
  );
};

export default General;
